import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const CatalogueSection = styled.section`
	width: 100%;
	padding-block: 80px 20px;
	${media.tablet} {
		padding-block: 60px 35px;
	}
	${media.mobile} {
		padding-block: 32px 43px;
	}
`;

export const ContainerStyles = css`
	@media screen and (width >= 1366px) {
		padding-right: 82px;
	}
`;
